import { useTranslation } from 'react-i18next';
import { ConfirmActionButton } from '~/components/overlays';
import { useArchiveRequestForQuote } from '~/api';
import { isRequestForQuoteArchivable } from './quoteAwarding';
import type {
  GetRequestForQuoteWithQuotesQuery,
  QuoteStatus,
} from '~/graphql/graphql';

type ArchiveRequestForQuoteButtonProps = Readonly<{
  requestForQuote: Pick<
    NonNullable<GetRequestForQuoteWithQuotesQuery['requestForQuote']>,
    'id' | 'status'
  >;
  quotes: ReadonlyArray<{ status: QuoteStatus }>;
}>;

export function ArchiveRequestForQuoteButton({
  requestForQuote,
  quotes,
}: ArchiveRequestForQuoteButtonProps) {
  const { t } = useTranslation('rfq-view');
  const { mutateAsync: archiveRequestForQuote, isPending } =
    useArchiveRequestForQuote();

  if (!isRequestForQuoteArchivable(requestForQuote.status, quotes)) {
    return null;
  }

  return (
    <ConfirmActionButton
      triggerLabel={t('rfq_view.archive_request')}
      triggerProps={{ variant: 'destructive-outline' }}
      title={t('rfq_view.archive_request')}
      message={t('rfq_view.archive_request_confirm_message')}
      cancelLabel={t('rfq_view.archive_cancel')}
      confirmLabel={t('rfq_view.archive_request_confirm')}
      successMessage={t('rfq_view.rfq_archived')}
      isPending={isPending}
      onConfirm={() => archiveRequestForQuote({ id: requestForQuote.id })}
    />
  );
}
